module.exports = __webpack_public_path__ + "static/media/lexus-logo.5c1ec694.svg";